import { render, staticRenderFns } from "./Subnavigation.vue?vue&type=template&id=b0b24388&"
import script from "./Subnavigation.vue?vue&type=script&lang=js&"
export * from "./Subnavigation.vue?vue&type=script&lang=js&"
import style0 from "./Subnavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports